import axios from "axios";
import { apiUrl, logApiError } from "@/shared/services/config.js";
import {
  ContactResponse,
  InsuredDataResponse,
  InsureWithLocationUpdatedRequest,
  LocationMasterResponse,
} from "@/shared/dtos/index.js";

/** @returns {Promise<InsuredDataResponse>} */
export const fetchInsuredDetails = async () => {
  try {
    const response = await axios.get(
      apiUrl("/insured/details"),
      { withCredentials: true },
    );
    return new InsuredDataResponse(response.data);
  } catch (error) {
    logApiError(error);
    throw error;
  }
};

/** @returns {Promise<ContactResponse[]>} */
export const fetchInsuredContacts = async () => {
  try {
    const response = await axios.get(
      apiUrl("/insured/contacts"),
      { withCredentials: true },
    );
    return Array.isArray(response.data)
      ? response.data.map((c) => new ContactResponse(c))
      : [];
  } catch (error) {
    const status = error?.response?.status;
    if (status === 404) return [];
    logApiError(error);
    throw error;
  }
};

/** @returns {Promise<LocationMasterResponse[]>} */
export const fetchInsuredLocations = async () => {
  try {
    const response = await axios.get(
      apiUrl("/insured/locations"),
      { withCredentials: true },
    );
    return Array.isArray(response.data)
      ? response.data.map((l) => new LocationMasterResponse(l))
      : [];
  } catch (error) {
    logApiError(error);
    throw error;
  }
};

/**
 * PUT /insured/with-location — update insured master + location together.
 * @param {Partial<InsureWithLocationUpdatedRequest>} payload
 */
export const putInsuredWithLocation = async (payload) => {
  try {
    const response = await axios.put(
      apiUrl("/insured/with-location"),
      new InsureWithLocationUpdatedRequest(payload),
      { withCredentials: true },
    );
    return response.data;
  } catch (error) {
    logApiError(error);
    throw error;
  }
};
